import LogoMini from "../../../components/icons/LogoMini";
import PlayTriangle from "../../../components/icons/PlayTriangle";
import "../general.scss";
import "./index.scss";
import DMenu from "../../../assets/img/SolutionsIcons/AgilysysIGDigitalMenu.svg";
import { Header } from "../../../components/Header";

const DigitalMenuFPage = () => {
  return (
    <div className="page splash digitalMenuFPage">
      <div className="page-title">
        <img src={DMenu} alt="" />
      </div>
      <Header />
      <div className="text-blocks">
        <div className="std-text">
          IG Digital Menu Board provides a cloud-native large-format digital
          display on industry standard technology to present high quality images
          and menus for a variety of venues.
        </div>
        <div className="std-text">
          It allows users to create and design layouts using pre-defined
          templates, and schedule menus with auto-update at defined times for a
          specified menu list. It also supports rotating menus with promo prices
          for items and combos.
        </div>
      </div>
      {/*<div className="play-video" onClick={()=>setShowVideo(true)}>
                <PlayTriangle />
                Play Video
            </div>*/}
      <img
        className="img-1"
        src={
          "https://storage.googleapis.com/popshap-kiosks-dev.appspot.com/agilysys/FeaturedSolutions/digitalMenu1.png"
        }
        alt=""
      />
    </div>
  );
};

export default DigitalMenuFPage;
